/* eslint-disable react/prop-types */
/* eslint-disable no-negated-condition */
/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import PropTypes from 'prop-types';

import React from 'react';
import styled from 'styled-components';
import Linkify from 'react-linkify';

import Localized from '../../../shared/components/Localized';
import { UtilityIcon } from '../SVGIcon';
import Button from '../Button';
import SubscriptionChannel from '../SubscriptionChannel';

const ModelDiv = styled.div`
  width: 100%;
  min-height: 29.55rem;
  @media (min-width: 20rem) and (max-width: 30rem) {
    width: 100%;
    height: 27.5rem;
  }
`;

export const ModelHeader = styled.div`
  display: flex;
  flex-direction: column;
  height: 5.4286rem;
  border-top-right-radius: 0.25rem;
  border-top-left-radius: 0.25rem;
  border-bottom: 2px solid #dddbda;
  background-color: #ffffff;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  @media (min-width: 20rem) and (max-width: 30rem) {
    height: 4.7143rem;
  }
`;
export const ModelHeading = styled.h2`
  font-family: 'Salesforce Sans';
  font-size: 1.25rem;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: center;
  color: #2b2826;
  @media (min-width: 22.8571rem) and (max-width: 34.2857rem) {
    height: 4.7143rem;
    font-size: 1.2857rem;
    text-align: center;
  }
`;
export const ModelSubHeader = styled.p`
  font-family: 'Salesforce Sans';
  font-size: 0.8571rem;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  margin-top: 0.5rem;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: center;
  color: #706e6b;
`;
export const ModelIntro = styled.p`
  margin-bottom: 0.9992rem;
  font-family: 'Salesforce Sans';
  font-size: 0.75rem;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: #706e6b;
`;

const PhoneNumberInput = styled.input`
  background: rgb(255, 255, 255);
  border-radius: 0.25rem;
  border: 0.0625rem solid rgb(221, 219, 218);
  height: 2.0625rem;
  width: 14.8125rem;
  display: inline;
  margin-left: 1rem;
  margin-top: 0.875rem;
`;

const SignupButton = styled(Button)`
  margin-top: 0.1829rem;
  font-family: 'Salesforce Sans';
  font-size: 0.75rem;
  letter-spacing: normal;
  text-align: center;
  @media (min-width: 20rem) and (max-width: 30rem) {
    margin-top: 1.125rem;
  }
`;

const MobileNumberInputDiv = styled.div`
  background: rgb(244, 246, 249);
  border-radius: 0.25rem;
  width: 27.3125rem;
  min-height: 8.8125rem;
  @media (min-width: 20rem) and (max-width: 30rem) {
    min-height: 8.8125rem;
    max-width: 19rem;
  }
`;
const MobileInputHeader = styled.p`
  padding-top: 0.8125rem;
  margin-left: 1.2617rem;
  font-family: 'Salesforce Sans';
  font-size: 0.75rem;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 0.0625rem;
  color: #54698d;
  @media (min-width: 20rem) and (max-width: 30rem) {
    margin-left: 0.75rem;
  }
`;

const VerifyButton = styled(Button)`
  margin-left: 0.375rem;
  height: 2.0625rem;
  margin-bottom: 0.1875rem;
  display: inline;
  font-family: 'Salesforce Sans';
  font-size: 0.75rem;
  letter-spacing: normal;
  text-align: center;

  @media (min-width: 20rem) and (max-width: 30rem) {
    margin-left: 1rem;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
`;
const VerificationInformation = styled.p`
  color: rgb(112, 110, 107);
  font-family: Salesforce Sans
  font-size: 0.75rem;
  font-weight: normal;
  letter-spacing: 0rem;
  line-height: 1.125rem;
  padding-top: 0.8125rem;
  margin-left: 1rem;
`;
const AddPhoneNumberSpan = styled.span`
  font-face: Salesforce Sans
  font-size: 0.8125rem;
  color: #0070d2;
  display: flex;
  align-items: center;
`;

const VerifyPhoneNumberSpan = styled.span`
  font-face: Salesforce Sans
  font-size: 0.8125rem;
  color: #0070d2;
  display: inline
`;

const InputSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  @media (min-width: 20rem) and (max-width: 30rem) {
    margin: 0 0.5rem;
  }
`;

const SelectDiv = styled.div.attrs({
  className: 'slds-select_container',
})`
  margin-top: 1rem;
  height: 2rem;
  width: 11.25rem;
  @media (min-width: 20rem) and (max-width: 30rem) {
    flex-basis: 33.33%;
  }
`;

const InputComponent = styled.input`
  background: rgb(255, 255, 255);
  border-radius: 0.25rem;
  border: 0.0625rem solid rgb(221, 219, 218);
  height: 2rem;
  width: 12.9375rem;
  margin-left: 0.5rem;
  margin-top: 1rem;
  @media (min-width: 20rem) and (max-width: 30rem) {
    flex-basis: 66.66%;
  }
`;
const SkipAnchor = styled.a`
  color: rgb(0, 112, 210);
  font-family: 'Salesforce Sans';
  font-size: 0.8125rem;
  font-weight: normal;
  text-align: center;
  width: 1.625rem;
  text-decoration: none;
  margin-left: 0.625rem;
  @media (min-width: 20rem) and (max-width: 30rem) {
    display: none;
  }
`;

const CancelAnchor = styled.a`
  color: rgb(0, 112, 210);
  font-family: 'Salesforce Sans';
  font-size: 0.8125rem;
  font-weight: normal;
  text-align: center;
  text-decoration: none;
  margin-left: 0.625rem;
  @media (min-width: 20rem) and (max-width: 30rem) {
    margin-top: 1.2rem;
  }
`;
const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 6.2475rem;
  margin-top: 2.25rem;
  @media (min-width: 20rem) and (max-width: 30rem) {
    margin-left: 1rem;
  }
`;

const PhoneNumberOperation = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10.4rem;
  @media (min-width: 20rem) and (max-width: 30rem) {
    margin-left: 1rem;
  }
`;

const ButtonDiv = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  margin-top: 1rem;
  margin-left: 1.2617rem;
  @media (min-width: 20rem) and (max-width: 30rem) {
    margin-left: 0.5rem;
    margin-top: 0rem;
  }
`;

const MessageInformation = styled.p`
  color: rgb(112, 110, 107);
  font-family: Salesforce Sans;
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0px;
  line-height: 18px;
  margin-top: 0.5rem;
  @media (min-width: 20rem) and (max-width: 30rem) {
    max-width: 25rem;
    margin: 0.2rem 1rem;
  }
`;

const HorizontalDiv = styled.div`
  background: rgb(221, 219, 218);
  border-radius: 0px;
  height: 1px;
  max-width: 29.875rem;
  margin-right: ${props => (props.leftAligned ? '9.4063rem' : '6.2475rem')};
  @media (min-width: 20rem) and (max-width: 30rem) {
    margin-left: 1rem;
    max-width: 22rem;
  }
`;

export default class MobileNumberModal extends React.Component {
  static propTypes = {
    submit: PropTypes.func,
    closeModal: PropTypes.func,
    instanceKey: PropTypes.string,
    requests: PropTypes.object,
    isOpen: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      phoneNumberValid: false,
      submitted: false,
      emailSubscribed: true,
      smsSubscribed: false,
      phoneNumber: '',
      verificationCode: '',
      togglePhoneNumber: false,
      countryCode: '1',
    };
    this.clickTogglePhoneNumber = this.clickTogglePhoneNumber.bind(this);
  }

  clickTogglePhoneNumber() {
    this.setState({ togglePhoneNumber: !this.state.togglePhoneNumber });
  }

  render() {
    const {
      closeModal,
      requests,
      instanceKey,
      emailAddress,
      emailCheckBox,
      emailVerified,
      toggleEmail,
      mobileNumberVerified,
      smsCheckBox,
      phoneNumber,
      toggleSMS,
    } = this.props;
    const subscriber = requests.subscriber.value;
    return (
      <div>
        <ModelDiv>
          <ModelHeader>
            <ModelHeading>Subscribe to Notifications</ModelHeading>
            <ModelSubHeader>
              <Localized modelName={'instance'} modelKey={instanceKey} modelAttribute={'label'} />
            </ModelSubHeader>
          </ModelHeader>
          <ModalContent>
            <ModelIntro>I would like to receive notifications via</ModelIntro>
            <SubscriptionChannel
              subType="Email"
              subText={emailAddress}
              checked={emailCheckBox}
              verified={emailVerified}
              onChange={toggleEmail}
            />
            <SubscriptionChannel
              subType="SMS"
              subText={phoneNumber}
              checked={smsCheckBox}
              verified={mobileNumberVerified}
              onChange={toggleSMS}
            />
          </ModalContent>
          <PhoneNumberOperation>
            {!this.state.togglePhoneNumber && subscriber.phoneNumber === '' && (
              <div>
                <HorizontalDiv style={{ marginLeft: 0 }}></HorizontalDiv>
                <MessageInformation style={{ marginLeft: 0 }}>
                  <Linkify>
                    <p>
                      To manage your mobile number, go to <a href="/subscriptions">My Subscriptions </a> page.
                    </p>
                  </Linkify>
                </MessageInformation>
              </div>
            )}

            {this.state.togglePhoneNumber && !subscriber.mobileNumberVerified && (
              <MobileNumberInputDiv>
                {!subscriber.phoneNumber && (
                  <div>
                    <MobileInputHeader>ADD MOBILE NUMBER</MobileInputHeader>
                    <InputSection>
                      <SelectDiv>
                        <select
                          value={this.props.countryCode}
                          onChange={this.props.onCountryCodeChange}
                          className="slds-select"
                        >
                          <option value="1">USA (+1)</option>
                        </select>
                      </SelectDiv>
                      <InputComponent
                        className="slds-input"
                        placeholder="Enter your phone number"
                        value={this.props.phoneNumber}
                        onChange={this.props.onEmailChange}
                        onKeyPress={this.props.onKeyPress}
                        size={10}
                        type="digit"
                      />
                    </InputSection>
                    <ButtonDiv>
                      <SignupButton onClick={this.props.clickSubmit} theme="neutral">
                        Add
                      </SignupButton>
                      <CancelAnchor onClick={this.clickTogglePhoneNumber}> Cancel </CancelAnchor>
                    </ButtonDiv>
                  </div>
                )}
                {subscriber.phoneNumber && !subscriber.mobileNumberVerified && (
                  <div>
                    <VerificationInformation>
                      We sent you a code at {subscriber.phoneNumber}. Please enter the code that you received. Didn’t
                      receive a code? <a onClick={this.props.resendVerificationCode}>Send again</a>
                    </VerificationInformation>
                    <PhoneNumberInput
                      className="slds-input"
                      type="digit"
                      size={10}
                      maxLength={4}
                      onChange={this.props.onCodeChange}
                      value={this.props.verificationCode}
                      onKeyPress={this.props.onKeyPressVerfication}
                      placeholder="Enter the 4-digit verification code"
                    />
                    <VerifyButton onClick={this.props.submitVerificationCode} theme="neutral">
                      Verify
                    </VerifyButton>
                    <SkipAnchor onClick={this.clickTogglePhoneNumber}> Skip </SkipAnchor>
                  </div>
                )}
              </MobileNumberInputDiv>
            )}
          </PhoneNumberOperation>
          <PhoneNumberOperation>
            {subscriber.phoneNumber && !this.state.togglePhoneNumber && <HorizontalDiv></HorizontalDiv>}
            <MessageInformation>
              {subscriber.phoneNumber &&
                !subscriber.mobileNumberVerified &&
                'You will not receive SMS notifications until you verify your phone number.'}
              {(!subscriber.phoneNumber && this.state.togglePhoneNumber) ||
                (subscriber.mobileNumberVerified && <p>Message and Data rates may apply.</p>)}
              {subscriber.phoneNumber && (
                <Linkify>
                  <p>
                    To manage your mobile number, go to <a href="/subscriptions">My Subscriptions </a> page.
                  </p>
                </Linkify>
              )}
            </MessageInformation>
          </PhoneNumberOperation>
        </ModelDiv>
        <div className="slds-modal__footer">
          <div className="slds-x-small-buttons--horizontal">
            <button className="slds-button slds-button--neutral" onClick={closeModal}>
              <Localized modelName="modalFooter" modelAttribute="label" modelKey="Cancel" />
            </button>
            <button
              disabled={!this.props.smsCheckBox && !this.props.emailCheckBox}
              className="slds-button slds-button--brand"
              onClick={this.props.submitPreferenceNotification}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    );
  }
}
